import axios from "axios";

export const activarSubscripcion = async () => {
  const { data } = await axios.put("/api/current_user/activate");
  return data;
};
